import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";

const LeftTable = ({
  tableLeftList,
  loading,
  onAmountChange,
  limitAmount,
  onSelectedRowsChange,
}) => {
  console.log("limitAmount in left table:", limitAmount);

  const [selectedToggle, setSelectedToggle] = useState([]);

  const [settledAmounts, setSettledAmounts] = useState([]);

  //   const handleSelectToggle = (index, checked) => {
  //     if(selectedAmount>limitAmount){
  //         alert('Amount must not exceed limit!')
  //         return
  //     }
  //     setSelectedToggle((prev) => {
  //       const updated = [...prev];
  //       updated[index] = checked;
  //       console.log("updated::", updated);
  //       return updated;
  //     });
  //   };

  //   const handleSelectToggle = (index, checked) => {
  //   const rowAmount = Number(tableLeftList?.[index]?.AMOUNT || 0);

  //   const nextAmount = checked
  //     ? selectedAmount + rowAmount
  //     : selectedAmount - rowAmount;

  //   if (nextAmount > limitAmount) {
  //     alert("Amount must not exceed limit!");
  //     return;
  //   }

  //   setSelectedToggle((prev) => {
  //     const updated = [...prev];
  //     updated[index] = checked;
  //     return updated;
  //   });
  // };

  const handleSelectToggle = (index, checked) => {
    const rowAmount = Number(tableLeftList?.[index]?.AMOUNT || 0);

    const nextTotal = checked
      ? selectedAmount + rowAmount
      : selectedAmount - (settledAmounts[index] || 0);

    if (checked && nextTotal > limitAmount) {
      alert("Amount must not exceed limit!");
      return;
    }

    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      return updated;
    });

    setSettledAmounts((prev) => {
      const updated = [...prev];
      updated[index] = checked ? rowAmount : 0;
      return updated;
    });
  };

  const handleSettledChange = (index, value) => {
    const rowAmount = Number(tableLeftList?.[index]?.AMOUNT || 0);
    const numericValue = Number(value || 0);

    // if (numericValue > rowAmount) {
    //   alert("Settled amount cannot exceed row amount");
    //   return;
    // }

    const otherTotal = selectedAmount - (settledAmounts[index] || 0);
    if (otherTotal + numericValue > limitAmount) {
      alert("Amount must not exceed limit!");
      return;
    }

    setSettledAmounts((prev) => {
      const updated = [...prev];
      updated[index] = numericValue;
      return updated;
    });

    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = numericValue > 0;
      return updated;
    });
  };

  //   const selectedAmount = tableLeftList?.reduce((total, row, index) => {
  //   if (selectedToggle[index]) {
  //     return total + Number(row?.AMOUNT || 0);
  //   }
  //   return total;
  // }, 0);

  const selectedAmount = tableLeftList?.reduce((total, row, index) => {
    if (selectedToggle[index]) {
      return total + Number(settledAmounts[index] || 0);
    }
    return total;
  }, 0);

  // useEffect(() => {
  //   onAmountChange?.(selectedAmount);
  // }, [selectedAmount, onAmountChange]);

  useEffect(() => {
    onAmountChange?.(selectedAmount);
  }, [selectedAmount]);
  // }, [selectedAmount , settledAmounts]);

  useEffect(() => {
    console.log("selectedToggle:", selectedToggle);
  }, [selectedToggle]);

  // const selectedRows = tableLeftList
  //   ?.map((row, index) => {
  //     if (!selectedToggle[index]) return null;

  //     return {
  //       ...row,
  //       SETTLED_AMOUNT: settledAmounts[index] || 0,
  //       INDEX: index,
  //     };
  //   })
  //   .filter(Boolean);

  const selectedRows = useMemo(() => {
  return tableLeftList
    ?.map((row, index) => {
      if (!selectedToggle[index]) return null;

      return {
        ...row,
        SETTLED_AMOUNT: settledAmounts[index] || 0,
        INDEX: index,
      };
    })
    .filter(Boolean);
}, [tableLeftList, selectedToggle, settledAmounts]);

  // useEffect(() => {
  //   onSelectedRowsChange?.(selectedRows);
  // }, [selectedRows]);


  useEffect(() => {
  onSelectedRowsChange?.(selectedRows);
}, [selectedRows, onSelectedRowsChange]);

  return (
    <div className="  ">
      <h2 className="text-md text-gray-800 mt-3 mb-1">Settlements</h2>

    <div className="h-[30vh] w-full overflow-auto  ">
      <table className="relative text-xs border-collapse w-full">
        <thead>
          <tr className="">
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Settled
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-30">
              Select
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Type
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Type No
            </th>
            <th className="z-20 bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Amount
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Ref
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              JV Date
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Entry Ref
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              TR Sl No
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              job Code
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              JV Type
            </th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={11} className="py-6 text-center">
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></span>
                  Loading data...
                </div>
              </td>
            </tr>
          ) : tableLeftList?.length > 0 ? (
            tableLeftList.map((row, index) => (
              <tr key={index} className="text-xs">
                <td className="border bg-white px-2 py-1 text-right">
                  <input
                    type="number"
                    className="w-24 px-2 py-1 border-none rounded text-right text-xs bg-transparent"
                    value={settledAmounts[index] || row.SETTLED}
                    disabled={!selectedToggle[index]}
                    onChange={(e) => handleSettledChange(index, e.target.value)}
                  />
                </td>

                <td className="border w-24 bg-white  text-center">
                  <label className="relative inline-block w-[3.5em] h-[2em]">
                    <input
                      type="checkbox"
                      className="peer sr-only"
                      checked={!!selectedToggle[index]}
                      onChange={(e) =>
                        handleSelectToggle(index, e.target.checked)
                      }
                    />
                    <span
                      className="
                          absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
                          after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
                          after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
                          after:transition-all after:duration-300 after:ease-in-out
                          after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
                          peer-checked:bg-blue-500
                          peer-checked:after:translate-x-[1.5em]
                          peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
                          peer-active:after:w-[3em]
                          peer-checked:peer-active:after:translate-x-[0.5em]
                        "
                    ></span>
                  </label>
                </td>
                <td
                  className={`border  px-2 py-1 text-center ${
                    row?.TYPE === "C"
                      ? "bg-red-500 text-white"
                      : "bg-green-500 text-white"
                  }`}
                >
                  {row?.TYPE ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.type_no ?? "-"}
                </td>
                <td className="z-10  border bg-white px-2 py-1 text-right">
                  {row?.AMOUNT ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.REF ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left cursor-pointer">
                  {row?.JVDATE ? dayjs(row.JVDATE).format("DD/MM/YYYY") : "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.ENTRY_REF ?? "-"}
                </td>

                <td className="border bg-white px-2 py-1 text-right">
                  {row?.TR_SLNO ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.job_code ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.JVTYPE ?? "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={11} className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default LeftTable;
